import { render, staticRenderFns } from "./DropdownHeaderLogs.vue?vue&type=template&id=29135d52"
import script from "./DropdownHeaderLogs.vue?vue&type=script&lang=js"
export * from "./DropdownHeaderLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports